import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import checkIcon from '../../../asset/img/common/alertbutton_check_icon.svg';
import warningIcon from '../../../asset/img/common/alertbutton_warning_icon.svg';
import Chips from '../../../components/common/Chips';

const shouldForwardProp = prop => !['status'].includes(prop);

const getStatusStyle = status => {
  if (status == '1') {
    return `
      border: 1px solid var(--Primary-200);
      background: var(--GrayScale-0);
      
      .message {
        color: var(--GrayScale-600);
      }
    `;
  } else if (status === '2') {
    return `
      background: var(--GrayScale-100);

      .message {
        color: var(--Error-300);
      }
    `;
  } else {
    return `
      background: var(--GrayScale-100);



    `;
  }
};

const AlertButtonStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 10px;

  .message {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  ${({ status }) => getStatusStyle(status)}
`;

const AlertButton = ({ title, status, path, disabled = false, onOpen, ...rest }) => {
  const navigate = useNavigate();

  // 1 : 공제완료 2 : 공제불가 3 : 체크전

  const statusProps = () => {
    let icon;
    if (status == '1') {
      icon = <Chips color="success">완료</Chips>;
    } else if (status === '2') {
      icon = <img src={warningIcon} alt="warning" />;
    } else {
      icon = <img src={checkIcon} alt="check" />;
    }

    return icon;
  };

  return (
    <AlertButtonStyled
      status={status}
      onClick={() => !disabled && onOpen(rest.openType, 'checkList')}>
      <span className="message">{title}</span>
      {statusProps()}
    </AlertButtonStyled>
  );
};

export default AlertButton;
